export default "__VITE_ASSET__KmPgxWS3__"